import React, { useState, useEffect, useRef } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

function VocationalCollapsible({ open, children, title, image }) {
  const [isOpen, setIsOpen] = useState(open);
  const [height, setHeight] = useState(open ? undefined : 0);

  const ref = useRef(null);

  useEffect(() => {
    if (!height || !isOpen || !ref.current) return undefined;
    
    const resizeObserver = new ResizeObserver((el) => {
      setHeight(el[0].contentRect.height);
    });
    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [height, isOpen]);
 
  useEffect(() => {
    if (isOpen) setHeight(ref.current?.getBoundingClientRect().height);
    else setHeight(0);
  }, [isOpen]);

  const handleFilterOpening = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <div className="card" 
           style={{
            border: 'none', 
            boxShadow: '5px 22px 56.1276px rgba(55, 55, 55, 0.07)', 
            borderRadius: 20, 
            width: '100%',
            marginBottom: 30
        }}>
        <div className="vocational-collapsible" style={{display: 'flex', height: 99, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#D9FEF9', borderRadius: 20, }}>
          <h6 style={{margin: 0, marginLeft: 60, fontSize: 25, fontWeight: 400}}>{title}</h6>
          
          <button type="button" className="btn" onClick={handleFilterOpening}>
            {!isOpen ? (
              <FaPlus size={30} />
            ) : (
              <FaMinus size={30} />
            )}
          </button>
          
        </div>
      </div>
      <div style={{ height, overflow: 'hidden', transition: 'height 0.2s ease-in-out', width: '100%' }} >
            <div ref={ref} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
              {children}
            </div>
        </div>
    </>
  );
}

export default VocationalCollapsible;